import React from 'react';
import { Form, Input, Button, Card, Typography, Alert, Space } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { Navigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../hooks/useAuth';
import { LoginRequest } from '../../types';
import './Login.css';

const { Title, Text } = Typography;

const Login: React.FC = () => {
  const [form] = Form.useForm();
  const { login, isAuthenticated, isLoginLoading, loginError } = useAuth();
  const location = useLocation();
  const { t } = useTranslation();

  const from = (location.state as { from?: { pathname: string } })?.from?.pathname || '/dashboard';

  console.log('Login component - isAuthenticated:', isAuthenticated, 'isLoginLoading:', isLoginLoading);

  if (isAuthenticated) {
    console.log('User is authenticated, redirecting to:', from);
    return <Navigate to={from} replace />;
  }

  const handleSubmit = async (values: LoginRequest) => {
    try {
      console.log('Attempting login with:', values);
      const result = await login(values);
      console.log('Login result:', result);
      
      // Force page reload to dashboard after successful login
      console.log('Login successful, redirecting to dashboard');
      window.location.href = '/dashboard';
      
    } catch (error) {
      console.error('Login error:', error);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card-wrapper">
        <Card className="login-card">
          <Space direction="vertical" size="large" style={{ width: '100%', display: 'flex' }}>
            <div className="login-header">
              <Title level={2} style={{ textAlign: 'center', margin: 0 }}>
                OX Corp
              </Title>
              <Text type="secondary" style={{ textAlign: 'center', display: 'block' }}>
                {t('auth.adminPanel')}
              </Text>
            </div>

            {loginError ? (
              <Alert
                message={t('auth.loginError')}
                description={
                  loginError instanceof Error 
                    ? loginError.message 
                    : t('auth.invalidCredentials')
                }
                type="error"
                showIcon
                closable
              />
            ) : null}

            <Form
              form={form}
              name="login"
              onFinish={handleSubmit}
              autoComplete="off"
              size="large"
            >
              <Form.Item
                name="email"
                rules={[
                  { required: true, message: t('auth.enterEmail') },
                  { type: 'email', message: t('auth.invalidEmailFormat') },
                ]}
              >
                <Input
                  prefix={<UserOutlined />}
                  placeholder={t('auth.emailPlaceholder')}
                  autoComplete="email"
                />
              </Form.Item>

              <Form.Item
                name="password"
                rules={[{ required: true, message: t('auth.enterPassword') }]}
              >
                <Input.Password
                  prefix={<LockOutlined />}
                  placeholder={t('auth.passwordPlaceholder')}
                  autoComplete="current-password"
                />
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={isLoginLoading}
                  style={{ width: '100%' }}
                >
                  {isLoginLoading ? t('auth.loginInProgress') : t('auth.login')}
                </Button>
              </Form.Item>
            </Form>

          </Space>
        </Card>
      </div>
    </div>
  );
};

export default Login;
